export default __webpack_public_path__ + "f247fc590e02c428df8c1ab82bda7b52.jpg";